/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { DormerMaterialViewModel } from "../../../UseCaseRequests/DormerMaterials/DormerMaterialViewModel";
import { PriceCalculationStrategyDto } from "../../PriceCalculationStrategyDto";
import { DormerColorVisualizationType } from "../../../DormerColorVisualizationType";

export class DormerColorViewModel {
    id: string | null;
    name: string;
    colorCode: string;
    dormerMaterialId: string | null;
    dormerMaterial: DormerMaterialViewModel;
    textureUrl: string;
    priceCalculationStrategyId: string | null;
    priceCalculationStrategy: PriceCalculationStrategyDto;
    visualizationType: DormerColorVisualizationType;
    sort: number;
}
